export default {
  dataMotivo: [],
  listaSubmotivos: [],
  loading: false,
};
